











import Vue from "vue";

import IconChevronDown from "@joyz/app-core/assets/icons/transparent/ChevronDown.svg";

interface Props {
  disabled: boolean;
  title: string;
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "DropdownButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      icons: {
        chevronDown: IconChevronDown
      }
    };
  }
});
